var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home text-center"},[_c('h1',[_vm._v("Business screener")]),_c('p',[_vm._v("Описание системы")]),_c('router-link',{staticClass:"btn btn-success",attrs:{"to":"/reg"}},[_vm._v("Попробовать")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }